export function validateEndDate(endDate) {
    let maxDays = 30
    const currentDate = new Date();
    const endDateObj = new Date(endDate);

    // Check if end date is in the past
    if (endDateObj < currentDate) {
        return { isValid: false, message: "End time has already passed" };
    }

    // Calculate the maximum allowed date
    const maxAllowedDate = new Date(currentDate);
    maxAllowedDate.setDate(maxAllowedDate.getDate() + maxDays);

    // Check if end date exceeds the maximum allowed date
    if (endDateObj > maxAllowedDate) {
        const formattedMaxDate = maxAllowedDate.toLocaleString(); // Adjust formatting as needed
        return {
            isValid: false,
            message: `You can't select more than ${maxDays} days from today. Please select a date before ${formattedMaxDate}.`
        };
    }

    // Return valid status
    return { isValid: true, message: "" };
}